import React from 'react';
import { CoreMarketplaceCombinedMarketplaceSearch } from '../../schemas/rql';
import ErrorDisplay from '../discovery/error_display';
import { PageSettings } from './map_params';
import ListingGrid from './listing_grid';
import ListViewRowCard from '../list_view_row_card';

interface Props {
  useListView: boolean;
  listings: CoreMarketplaceCombinedMarketplaceSearch.Listings[];
  loading: boolean;
  error: boolean;
  showingSold: boolean;
  trackingName?: string;
  emptyGrid?: JSX.Element;
  trackingQuery?: string;
  pageSettings?: PageSettings;
}

export default function Listings(props: Props) {
  if (props.error) return <ErrorDisplay />;

  if (props.useListView) {
    if (!props.loading && props.listings.length === 0) {
      return props.emptyGrid;
    }

    return (
      <>
        {props.listings.map((listing, idx) => {
          return (
            <ListViewRowCard
              key={listing.id}
              listing={listing}
              loading={props.loading}
              position={idx}
              trackingQuery={props.trackingQuery}
              showingSold={props.showingSold}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      <ListingGrid
        loading={props.loading}
        error={!!props.error}
        listings={props.listings}
        showingSold={props.showingSold}
        emptyGrid={props.emptyGrid}
        trackingQuery={props.trackingQuery}
        pageSettings={props.pageSettings}
      />
    </>
  );
}
